import React from 'react';
import Count from '../Count/Count';


import HeaderBody from '../HeaderBody/HeaderBody';
import Service from '../Service/Service';
import Slider from '../Slider/Slider';
import Teacher from '../Teacher/Teacher';
import Teachers from '../Teachers.js/Teachers';

const Home = () => {
     return (
          <div className='container'>
               <HeaderBody></HeaderBody>
               <Count></Count>
               <Teacher></Teacher>
               <Service></Service>
               <Teachers></Teachers>
               <Slider></Slider>

          </div>
     );
};

export default Home;